export default __webpack_public_path__ + "static/media/480_dummy2016-psychotherapie01-de.b1216226.png";